import { render } from "./decline-dialog.vue?vue&type=template&id=a2363f48&ts=true"
import script from "./decline-dialog.vue?vue&type=script&lang=ts"
export * from "./decline-dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__